export const figure27 = {
    chart: {
        zoomType: 'xy',
        animation: false,
        marginTop: 50,
        marginLeft: 250,
        plotBackgroundColor: null,
        plotBorderWidth: null,
        plotShadow: false,
        type: 'bar',
        height: '1000px',
        backgroundColor: 'rgba(255, 255, 255, 0.0)',
        style: {
          fontFamily: 'Montserrat'
        }
      },
  
      colors: ['#5b9bd5'],
  
      credits: {
        enabled: false
      },
      title: {
        text: null
      },
      subtitle: {
        text: null
      },
      exporting: {
        enabled: false
      },

  xAxis: {
      categories: [
        "Malawi 2020",
        "Camboya 2014",
        "Myanmar 2015",
        "Burundi 2016",
        "Rwanda 2014",
        "Zimbabwe 2015",
        "Lesotho 2014",
        "República Unida de Tanzanía 2015",
        "Sierra Leona 2019",
        "Zambia 2018",
        "Etiopía 2016",
        "Malí 2018",
        "Botswana 2019",
        "Haití 2016",
        "Uganda 2016",
        "Chad 2014",
        "Indonesia 2017",
        "Nepal 2016",
        "Albania 2017",
        "Guatemala 2014",
        "Armenia 2015",
        "Nigeria 2019",
        "Perú 2018",
        "Camerún 2018",
        "Afganistán 2015",
        "Benin 2017",
        "Guinea-Bissau 2018",
        "Togo 2018",
        "Senegal 2018",
        "Burkina Faso 2014",
        "Côte d’Ivoire 2018",
        "Níger 2018",
        "India 2015",
      ],
      title: {
          text: null
      }
  },
  yAxis: {
      min: 0,
      max: 70,
      tickInterval: 10,
      title: {
          text: null,
      },
      labels: {
          overflow: 'justify'
      }
  },
  plotOptions: {
      bar: {
          dataLabels: {
              enabled: true
          }
      }
  },
  legend: {
      enabled: false,
  },
  series: [{
      name: 'Proporción de mujeres entre los propietarios o los titulares de derechos sobre tierras',
      data: [57.8, 53, 52.5, 51.2, 50.4, 49.8, 48.9, 47.6, 47.1, 44.9, 44.6, 41.7, 41.4, 41.2, 39.9, 38.2, 37.4, 37.4, 36.9, 36.1, 35.1, 32, 29.8, 29.2, 29.2, 25.3, 23.4, 22.7, 19.3, 17.3, 16.2, 14.7, 8.2] ,
  }]
}